import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { InsuranceType } from 'src/app/_enums/insurance-type.enum';
import {
  BUSINESS_INSURANCE_PAYMENT_FREQUENCY,
  getPaymentFrequencyLabel,
} from 'src/app/_enums/payment-frequency.enum';

import { LeadFormBase } from '../../lead-form-base';

@Component({
  selector: 'app-business-cyber-form',
  templateUrl: './business-cyber-form.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class BusinessCyberFormComponent
  extends LeadFormBase
  implements OnDestroy, OnInit
{
  @Input()
  formGroup!: FormGroup;

  hasClaimsSub!: Subscription;

  constructor(private fb: FormBuilder) {
    super();
  }

  metadataFormGroup: FormGroup = this.fb.group({
    type: InsuranceType.BUSINESS_CYBERSECURITY,
    startDate: [null],
    contractDuration: [null],
    paymentFrequency: [null],
    splitPaymentFee: [null],
    hasclaimsLastFiveYears: [null],
    claims: [null],

    thirdPartyDamages: this.fb.group({
      financialLossCivilResponsability: [null],
      insuranceSum: [null],
      availabilityDamage: [null],
      dataLoss: [null],
      hacking: [null],
      piracy: [null],
      privacyViolation: [null],
      paymentDataViolation: [null],
    }),

    ownDamages: this.fb.group({
      malwareRemoval: [null],
      dataRetrieval: [null],
      additionalFees: [null],
      paymentProcessing: [null],
      shippingDamage: [null],
      lossOperatingIncome: [null],
    }),

    assistance: this.fb.group({
      forensicsFee: [null],
      dataProtectionViolationFee: [null],
      crisisManagement: [null],
      legalProtection: [null],
      cyberBlackmail: [null],
      negociationFee: [null],
      ransomPayment: [null],
      insuranceSum: [null],
      generalDeductible: [null],
    }),
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.formGroup.removeControl('metadata');
    if (this.metadata) {
      this.metadataFormGroup.patchValue(this.metadata);
    }
    this.formGroup.addControl('metadata', this.metadataFormGroup);

    this.hasClaimsSub = this.metadataFormGroup.controls[
      'hasclaimsLastFiveYears'
    ].valueChanges.subscribe((value) => {
      if (value !== 'true' && value !== true) {
        this.metadataFormGroup.controls['claims'].reset();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.hasClaimsSub) this.hasClaimsSub.unsubscribe();
  }

  paymentFrequencyValues = BUSINESS_INSURANCE_PAYMENT_FREQUENCY;

  getPaymentFrequencyLabel = getPaymentFrequencyLabel;
}
